import { render } from "./SurveyPlusSummary.vue?vue&type=template&id=4ee64bec&ts=true"
import script from "./SurveyPlusSummary.vue?vue&type=script&lang=ts"
export * from "./SurveyPlusSummary.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__